import { Networks } from "../../constants/blockchain";
import { LPBond, CustomLPBond } from "./lp-bond";
import { StableBond, CustomBond } from "./stable-bond";

import MimIcon from "../../assets/tokens/MIM.svg";
import AvaxIcon from "../../assets/tokens/AVAX.svg";
import MimDbIcon from "../../assets/tokens/DB-MIM.png";
import AvaxDbIcon from "../../assets/tokens/DB-AVAX.png";

import { StableBondContract, LpBondContract, WavaxBondContract, StableReserveContract, LpReserveContract } from "../../abi";

export const mim = new StableBond({
    name: "mim",
    displayName: "MIM",
    bondToken: "MIM",
    bondIconSvg: MimIcon,
    bondContractABI: StableBondContract,
    reserveContractAbi: StableReserveContract,
    networkAddrs: {
        [Networks.AVAX]: {
            bondAddress: "0xe04D7f52D61B0fE5061Ac49D4d973aA80144193C",
            reserveAddress: "0x130966628846bfd36ff31a822705796e8cb8c18d",
        },
        [Networks.FUJI]: {
            bondAddress: "0xe132B78184753eE53187F27AaDbcee0306FB84a5",
            reserveAddress: "0xfE162B97497dB5942604833Cba13E57A66Ce0391",
        },
    },
    tokensInStrategy: "0",
});

export const wavax = new CustomBond({
    name: "wavax",
    displayName: "wAVAX",
    bondToken: "AVAX",
    bondIconSvg: AvaxIcon,
    bondContractABI: WavaxBondContract,
    reserveContractAbi: StableReserveContract,
    networkAddrs: {
        [Networks.AVAX]: {
            bondAddress: "0x252130c711157eD251c7E1d54FaF73672E186850",
            reserveAddress: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
        },
        [Networks.FUJI]: {
            bondAddress: "0xBe33FAcA2DC19fC3F34f80Bd42aB3B72562Eb004",
            reserveAddress: "0xd00ae08403b9bbb9124bb305c09058e32c39a48c",
        },
    },
    tokensInStrategy: "0",
});

export const mimDb = new LPBond({
    name: "mim_db_lp",
    displayName: "DB-MIM LP",
    bondToken: "MIM",
    bondIconSvg: MimDbIcon,
    bondContractABI: LpBondContract,
    reserveContractAbi: LpReserveContract,
    networkAddrs: {
        [Networks.AVAX]: {
            bondAddress: "0x81Edd94fB7303D1F275C792446CC5E25C54D19dB",
            reserveAddress: "0x1ab6844e765335c94d749e73bedd8d228bc9f1d0",
        },
        [Networks.FUJI]: {
            bondAddress: "0x9185a696689D182742f9370C04bA1b05888F58fA",
            reserveAddress: "0xc7d96be44090d8a25c0d52733e22ddfd57ae4004",
        },
    },
    lpUrl: "https://www.traderjoexyz.com/#/pool/0x3B760B2527a4C2bb5E0F2B9e7BC77744adE2484E/0x130966628846bfd36ff31a822705796e8cb8c18d",
});

export const avaxDb = new CustomLPBond({
    name: "avax_db_lp",
    displayName: "DB-AVAX LP",
    bondToken: "AVAX",
    bondIconSvg: AvaxDbIcon,
    bondContractABI: LpBondContract,
    reserveContractAbi: LpReserveContract,
    networkAddrs: {
        [Networks.AVAX]: {
            bondAddress: "0x88407D8ecc2561595907C18aDEA62527b8Ac297E",
            reserveAddress: "0xe4d460aba520d0016c4ff5d321e54b3e6ce54866",
        },
        [Networks.FUJI]: {
            bondAddress: "0x491e860A0188e91500feD64d4BcE8f96D6689dD7",
            reserveAddress: "0x439d25a6f91c0342d54b63ec1e3b9a079a45fdaf",
        },
    },
    lpUrl: "https://www.traderjoexyz.com/#/pool/0x3B760B2527a4C2bb5E0F2B9e7BC77744adE2484E/AVAX",
});

export default [mim, wavax, mimDb, avaxDb];
